import logger from '@eneco/common/log';

export default async function sha256Hash(message: string): Promise<string> {
  // Encode the message as UTF-8
  const msgBuffer = new TextEncoder().encode(message);

  // Generate the hash using Web Crypto API
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

  // Convert the hash to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  return hashHex;
}

/**
 * Never throws: a failed hash must not take the whole dataLayer push down.
 */
export const getEncodedCustomerId = async (customerId?: string | null): Promise<string | undefined> => {
  if (!customerId) return undefined;
  try {
    return await sha256Hash(customerId.toString());
  } catch (error) {
    logger.info('qyK2jh', 'Could not hash the customer id for the dataLayer', error);
    return undefined;
  }
};
